<template>
  <el-dialog
    title="添加无车承运人用户"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="createForm"
      label-width="100px"
    >
      <el-form-item label="平台名称" prop="appId">
        <el-select
          v-model="form.appId"
          filterable
          remote
          :remote-method="fetchAppList"
          :loading="appLoading"
          placeholder="请输入平台名称搜索"
          style="width: 100%"
          @change="handleAppChange"
        >
          <el-option
            v-for="item in appList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="渠道" prop="channelId">
        <el-select
          v-model="form.channelId"
          filterable
          remote
          :remote-method="filterChannelList"
          :loading="channelLoading"
          placeholder="请输入渠道名称搜索"
          style="width: 100%"
          :disabled="!form.appId"
        >
          <el-option
            v-for="item in filteredChannelList"
            :key="item.id"
            :label="item.realname + (item.alias ? '(' + item.alias + ')' : '')"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="价格方案" prop="priceId">
        <el-select
          v-model="form.priceId"
          filterable
          placeholder="请选择价格方案"
          style="width: 100%"
        >
          <el-option
            v-for="item in pricePlanOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="手机号" prop="mobile">
        <el-input
          v-model="form.mobile"
          placeholder="请输入手机号"
          maxlength="11"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading"
        >保 存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getAppList, getChannelList, getWccyrPriceList, createWccyrUser } from '@/api/member'

export default {
  name: 'CreateWccyrUser',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 手机号验证规则
    const validateMobile = (rule, value, callback) => {
      const reg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57]|19[0-9]|16[0-9])[0-9]{8}$/
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: this.visible,
      submitLoading: false,
      appLoading: false,
      channelLoading: false,
      appList: [],
      channelList: [],
      filteredChannelList: [],
      pricePlanOptions: [],
      form: {
        appId: '',
        channelId: '',
        priceId: '',
        mobile: ''
      },
      rules: {
        appId: [{ required: true, message: '请选择平台', trigger: 'change' }],
        channelId: [
          { required: true, message: '请选择渠道', trigger: 'change' }
        ],
        priceId: [
          { required: true, message: '请选择价格方案', trigger: 'change' }
        ],
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.fetchAppList()
        this.fetchPriceList()
        this.resetForm()
      }
    },
    'form.appId'(newVal) {
      if (newVal) {
        this.fetchChannelList(newVal)
      } else {
        this.filteredChannelList = []
        this.form.channelId = ''
      }
    }
  },
  methods: {
    // 获取平台列表（支持模糊搜索）
    async fetchAppList(query) {
      this.appLoading = true
      try {
        const params = query ? { name: query } : {}
        const res = await getAppList(params)
        this.appList = res.rows || []
      } catch (error) {
        console.error('获取平台列表失败:', error)
        this.$message.error('获取平台列表失败')
      } finally {
        this.appLoading = false
      }
    },

    // 获取渠道列表
    async fetchChannelList(appId) {
      this.channelLoading = true
      try {
        const res = await getChannelList({ app_id: appId })
        this.channelList = res.rows || []
        this.filteredChannelList = this.channelList
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        this.$message.error('获取渠道列表失败')
      } finally {
        this.channelLoading = false
      }
    },

    // 过滤渠道列表（支持模糊搜索）
    filterChannelList(query) {
      if (query) {
        this.filteredChannelList = this.channelList.filter(item => {
          const nameMatch = item.name && item.name.toLowerCase().includes(query.toLowerCase())
          const aliasMatch = item.alias && item.alias.toLowerCase().includes(query.toLowerCase())
          return nameMatch || aliasMatch
        })
      } else {
        this.filteredChannelList = this.channelList
      }
    },

    // 获取价格方案列表
    async fetchPriceList() {
      try {
        const res = await getWccyrPriceList()
        this.pricePlanOptions = res.rows || []
      } catch (error) {
        console.error('获取价格方案列表失败:', error)
        this.$message.error('获取价格方案列表失败')
      }
    },

    // 平台选择变化
    handleAppChange(val) {
      this.form.channelId = ''
      if (val) {
        this.fetchChannelList(val)
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.createForm && this.$refs.createForm.resetFields()
      this.channelList = []
      this.filteredChannelList = []
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            const params = {
              app_id: this.form.appId,
              channel_id: this.form.channelId,
              gxb_price_id: this.form.priceId,
              mobile: this.form.mobile,
              type: 1  // 无车承运人用户类型
            }
            
            // 使用无车承运人用户创建接口
            const res = await createWccyrUser(params)
            if (res.err_code === 0) {
              this.$message.success('创建成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(res.err_msg || '创建失败')
            }
          } catch (error) {
            console.error('创建无车承运人用户失败:', error)
            this.$message.error('创建失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>